import { SVGProps } from "react";

export const Trophy3Icon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        d="m13 15.5 -0.5 -3.5 5 -2.5 1 -9h-14l1 9 5 2.5 -0.5 3.5 -4 3H4.5v5h14v-5H17l-4 -3Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M18.5 21.5h-14v2h14v-2Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M11.5 18.5H17l-4 -3 -0.5 -3.5h-1v6.5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M11.5 0.5h7l-1 9 -6 3V0.5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m17.5 9.5 -6 3 -6 -3 -1 -9h14l-1 9Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.5 18.5h-14v5h14v-5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.722 2.5H2.5v4l2.847 1.627"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.278 2.5H20.5v4l-2.847 1.627"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 21.5h14"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m11.505 2.5 0.995 2H15l-2 2L14 9l-2.5 -1.312L9 9l1 -2.5 -2 -2h2.5l1.005 -2Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m10.5 12 -0.5 3.5 -4 3h11l-4 -3 -0.5 -3.5"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
